import React from "react";
import "../styles/components/PrivacyPolicy.css";
import Navigation from "../components/Navigation/Navigation.js"; // Adjust path if needed
import Footer from "../components/Footer.js"


export default function PrivacyPolicy() {
  return (
    <>
      <Navigation />
      <div className="privacy-container">
        <div className="privacy-box">
          <h1>Privacy Policy</h1>
          <p><em>Last Updated: August 2025</em></p>

          <p>
            At <strong>Flight Reservation Hub</strong>, accessible from{" "}
            <a href="https://flightreservationhub.com" target="_blank" rel="noreferrer">
              https://flightreservationhub.com
            </a>
            , your privacy is one of our top priorities. This Privacy Policy
            explains how we collect, use, and protect your personal data when
            you use our services.
          </p>

          <h2>1. Information We Collect</h2>
          <p>We may collect:</p>
          <ul>
            <li><strong>Personal Information:</strong> Name, email, phone number, and payment details.</li>
            <li><strong>Travel Details:</strong> Flight preferences, destinations, and booking history.</li>
            <li><strong>Technical Data:</strong> IP address, browser type, and cookies.</li>
          </ul>

          <h2>2. How We Use Your Information</h2>
          <ul>
            <li>Process bookings and provide customer support.</li>
            <li>Personalize your experience and recommend flights.</li>
            <li>Improve website functionality and security.</li>
            <li>Send booking confirmations, updates, and offers.</li>
            <li>Comply with legal requirements.</li>
          </ul>

          <h2>3. Sharing Your Information</h2>
          <p>
            We do <strong>not</strong> sell your data. We may share your information with airlines,
            payment processors, service providers, or legal authorities when required.
          </p>

          <h2>4. Cookies and Tracking</h2>
          <p>
            We use cookies to enhance your experience. You can manage cookies in
            your browser settings.
          </p>

          <h2>5. Data Security</h2>
          <p>
            We implement industry-standard security measures to protect your
            information. However, no online service can guarantee 100% security.
          </p>

          <h2>6. Your Rights</h2>
          <p>
            You may request access, correction, or deletion of your data. Contact us at:{" "}
            <a href="mailto:support@flightreservationhub.com">
              support@flightreservationhub.com
            </a>
            .
          </p>

          <h2>7. Children's Privacy</h2>
          <p>
            We do not knowingly collect data from children under 13.
          </p>

          <h2>8. Changes to This Policy</h2>
          <p>
            We may update this policy periodically. Updates will be posted here
            with a new “Last Updated” date.
          </p>

          <h2>9. Contact Us</h2>
          <p>
            For questions, email us at{" "}
            <a href="mailto:support@flightreservationhub.com">
              support@flightreservationhub.com
            </a>
            .
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
}
